import { Form, Show, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import { useMemo } from "react";
import "react-mde/lib/styles/css/react-mde-all.css";
import { ITransaction } from "types/transaction.interface";

export const QuestionShow: React.FC<IResourceComponentsProps> = () => {
  const { formProps } = useForm<ITransaction>();

  const { queryResult } = useShow<ITransaction>();
  const { data, isLoading } = queryResult;
  const record: any = data?.data;

  const formItems = useMemo(() => {
    return [
      {
        type: "object",
        label: "User",
        name: "user",
        children: "email",
      },
      {
        label: "Full Name",
        name: "fullName",
      },
      {
        label: "Email Address",
        name: "emailAddress",
      },
      // {
      //     type: 'object',
      //     label: 'Email',
      //     name: 'user',
      //     children: 'email',
      // },
      {
        label: "Reason",
        name: "reason",
      },
      {
        label: "Content",
        name: "content",
      },
    ];
  }, []);

  return (
    <Show isLoading={isLoading} canEdit={false}>
      <Form {...formProps} layout="vertical">
        {formItems.map(({ label, name, type, children }, index) => (
          <Form.Item label={label} name={name} key={index}>
            {type === "object"
              ? record?.data?.[name][children]
              : record?.data[name]}
          </Form.Item>
        ))}
      </Form>
    </Show>
  );
};
